import { readSessionNumber, removeSessionItem, writeSessionNumber } from "@/shared-utils/sessionStorageNumber";

/** Why the agent moved to Offline: End Shift, right after a Connect auth failure, or anything else. */
export type OfflineSource = "end-shift" | "auth-failure" | "unrequested";

const SHIFT_END_REQUESTED_KEY = "ewp-shift-end-requested";

/*
 * When the expert clicked "End your shift", to tell that Offline from one set elsewhere (another CCP
 * page such as the enterprise EVL tab, a supervisor, a softphone or auth failure). sessionStorage: per
 * tab, and survives the reload a busy expert's queued Offline can outlast. Logout clears it. Blocked
 * storage reads as no request, so the Offline counts as unrequested.
 */

export function requestShiftEnd(now = Date.now()): void {
    writeSessionNumber(SHIFT_END_REQUESTED_KEY, now);
}

export function clearShiftEndRequest(): void {
    removeSessionItem(SHIFT_END_REQUESTED_KEY);
}

/** Milliseconds since End Shift was clicked, or undefined when there is no readable request. */
export function getShiftEndRequestAge(now = Date.now()): number | undefined {
    const requestedAt = readSessionNumber(SHIFT_END_REQUESTED_KEY);
    return requestedAt === undefined ? undefined : now - requestedAt;
}

export function isShiftEndRequested(): boolean {
    return getShiftEndRequestAge() !== undefined;
}

/** A direct (not queued) End Shift Offline lands within this window. */
const DIRECT_OFFLINE_WINDOW_MS = 30_000;

/** Requested in this tab, and either Connect's queued next state or right after the click. */
export function isShiftEndOffline(requestAge: number | undefined, offlineWasQueued: boolean): boolean {
    return requestAge !== undefined && (offlineWasQueued || requestAge <= DIRECT_OFFLINE_WINDOW_MS);
}
